module.exports = __webpack_public_path__ + "static/full03-e6858694784586d7318604c0efdb1f0b.png";